// extracted by mini-css-extract-plugin
export var overflow = "Section-module--overflow--7079f";
export var section = "Section-module--section--1e8ec";
export var sectionContainer = "Section-module--section__container--932c2";